export const SPONSOR_PRESENTMENT_FX_SNAPSHOT_DATE = '2026-06-29';
export const XOF_PER_EUR = 655.957;
export const SPONSOR_PRESENTMENT_CURRENCIES = [
    {
        code: 'XOF',
        decimals: 0,
        exact: true,
        name: 'West African CFA franc',
        region: 'Africa',
        xofPerUnit: 1,
    },
    {
        code: 'EUR',
        decimals: 2,
        exact: true,
        name: 'Euro',
        region: 'Europe',
        xofPerUnit: XOF_PER_EUR,
    },
    {
        code: 'USD',
        decimals: 2,
        name: 'US dollar',
        region: 'Americas',
        xofPerUnit: 575.0981939330177,
    },
    {
        code: 'GBP',
        decimals: 2,
        name: 'British pound',
        region: 'Europe',
        xofPerUnit: 760.8386011714899,
    },
    {
        code: 'CAD',
        decimals: 2,
        name: 'Canadian dollar',
        region: 'Americas',
        xofPerUnit: 404.8867353867045,
    },
    {
        code: 'CHF',
        decimals: 2,
        name: 'Swiss franc',
        region: 'Europe',
        xofPerUnit: 711.2958143569724,
    },
    {
        code: 'SEK',
        decimals: 2,
        name: 'Swedish krona',
        region: 'Europe',
        xofPerUnit: 59.16718531547378,
    },
    {
        code: 'NOK',
        decimals: 2,
        name: 'Norwegian krone',
        region: 'Europe',
        xofPerUnit: 57.89814201862395,
    },
    {
        code: 'DKK',
        decimals: 2,
        name: 'Danish krone',
        region: 'Europe',
        xofPerUnit: 87.75931500434811,
    },
    {
        code: 'PLN',
        decimals: 2,
        name: 'Polish zloty',
        region: 'Europe',
        xofPerUnit: 153.0000233247032,
    },
    {
        code: 'AUD',
        decimals: 2,
        name: 'Australian dollar',
        region: 'Oceania',
        xofPerUnit: 396.80418607464765,
    },
    {
        code: 'NZD',
        decimals: 2,
        name: 'New Zealand dollar',
        region: 'Oceania',
        xofPerUnit: 325.13358116480794,
    },
    {
        code: 'JPY',
        decimals: 0,
        name: 'Japanese yen',
        region: 'Asia',
        xofPerUnit: 3.5530115913768823,
    },
    {
        code: 'CNY',
        decimals: 2,
        name: 'Chinese yuan',
        region: 'Asia',
        xofPerUnit: 84.64835079750168,
    },
    {
        code: 'INR',
        decimals: 2,
        name: 'Indian rupee',
        region: 'Asia',
        xofPerUnit: 6.082800126115099,
    },
    {
        code: 'ZAR',
        decimals: 2,
        name: 'South African rand',
        region: 'Africa',
        xofPerUnit: 35.03426212259591,
    },
    {
        code: 'BRL',
        decimals: 2,
        name: 'Brazilian real',
        region: 'Americas',
        xofPerUnit: 111.3698025433369,
    },
    {
        code: 'MXN',
        decimals: 2,
        name: 'Mexican peso',
        region: 'Americas',
        xofPerUnit: 32.90908269952439,
    },
];
const SPONSOR_PRESENTMENT_BY_CODE = new Map(SPONSOR_PRESENTMENT_CURRENCIES.map((currency) => [currency.code, currency]));
export function listSponsorPresentmentCurrencies() {
    return SPONSOR_PRESENTMENT_CURRENCIES;
}
export function isSponsorPresentmentCurrency(value) {
    return SPONSOR_PRESENTMENT_BY_CODE.has(value);
}
export function sponsorPresentmentCurrencyMeta(code) {
    const meta = SPONSOR_PRESENTMENT_BY_CODE.get(code);
    if (meta === undefined) {
        throw new Error('Unsupported sponsor presentment currency.');
    }
    return meta;
}
export function isSponsorPresentmentRateExact(code) {
    return sponsorPresentmentCurrencyMeta(code).exact === true;
}
export function quoteSponsorPriceFromXof(xofAmountMinor, code) {
    if (!isSponsorPresentmentCurrency(code)) {
        throw new Error('Unsupported sponsor presentment currency.');
    }
    const meta = sponsorPresentmentCurrencyMeta(code);
    const amount = xofAmountMinor / meta.xofPerUnit;
    return {
        amount,
        amountMinor: Math.round(amount * 10 ** meta.decimals),
        code,
        estimate: !isSponsorPresentmentRateExact(code),
    };
}
export function formatSponsorPresentmentCurrency(amount, code, locale) {
    try {
        return new Intl.NumberFormat(locale, {
            currency: code,
            currencyDisplay: 'narrowSymbol',
            style: 'currency',
        }).format(amount);
    }
    catch {
        return `${new Intl.NumberFormat(locale).format(Math.round(amount))} ${code}`;
    }
}
//# sourceMappingURL=sponsor-presentment-currency.js.map